<template>
  <div>
    <div class="i-layout-page-header">
      <div class="i-layout-page-header">
        <span class="ivu-page-header-title">{{ $route.meta.title }}</span>
      </div>
    </div>
    <Card :bordered="false" dis-hover class="ivu-mt">

      <Table :columns="columns" stripe :data="tableData" ref="table" class="ivu-mt"
             :loading="loading"
             no-userFrom-text="暂无数据"
             no-filtered-userFrom-text="暂无筛选结果"
             height="500"
      >

        <template slot-scope="{ row, index }" slot="action">
          <a @click="edit(row.id)">编辑</a>
          <Divider type="vertical"/>
          <a @click="log(row.device_sn)">历史记录</a>
        </template>

      </Table>
    </Card>
  </div>
</template>

<script>
import {plantDeviceMeteorologyListApi} from '@/api/plant/plantDevice'

export default {
  name: 'plantDeviceMeteorologyList',
  inject: ['reload'],
  data() {
    return {
      grid: {
        xs: 24,
        sm: 24,
        md: 12,
        lg: 7,
        xl: 7
      },
      tableData: [],
      loading: false,
      columns: [
        {
          title: '所在基地',
          key: 'land_base',
          minWidth: 120
        },
        {
          title: '设备编号',
          key: 'device_sn',
          minWidth: 120
        },
        {
          title: '设备厂商',
          key: 'company',
          align: 'center',
          minWidth: 120
        },
        {
          title: '监测数据',
          align: 'center',
          children: [
            {
              title: '空气湿度',
              align: 'center',
              minWidth: 100,
              render: (h, { row }) => {
                return h('div', row.monitoring.air_humidity ? row.monitoring.air_humidity : '-');
              }
            },
            {
              title: '空气温度',
              align: 'center',
              minWidth: 100,
              render: (h, { row }) => {
                return h('div', row.monitoring.air_temperature ? row.monitoring.air_temperature : '-');
              }
            },
            {
              title: '光照',
              align: 'center',
              minWidth: 100,
              render: (h, { row }) => {
                return h('div', row.monitoring.light ? row.monitoring.light : '-');
              }
            },
            {
              title: '风向',
              align: 'center',
              minWidth: 100,
              render: (h, { row }) => {
                return h('div', row.monitoring.wind_direction ? row.monitoring.wind_direction : '-');
              }
            },
            {
              title: '风速',
              align: 'center',
              minWidth: 100,
              render: (h, { row }) => {
                return h('div', row.monitoring.wind_speed ? row.monitoring.wind_speed : '-');
              }
            },
            {
              title: '光合',
              align: 'center',
              minWidth: 100,
              render: (h, { row }) => {
                return h('div', row.monitoring.illumination ? row.monitoring.illumination : '-');
              }
            },
            {
              title: '雨量',
              align: 'center',
              minWidth: 100,
              render: (h, { row }) => {
                return h('div', row.monitoring.rainfall ? row.monitoring.rainfall : '-');
              }
            },
            {
              title: '大气压',
              align: 'center',
              minWidth: 100,
              render: (h, { row }) => {
                return h('div', row.monitoring.atmospheric_pressure ? row.monitoring.atmospheric_pressure : '-');
              }
            },
          ]
        },
        {
          title: '设备状态',
          align: 'center',
          key: 'status_msg',
          minWidth: 120
        },
        {
          title: '更新时间',
          key: 'last_time',
          minWidth: 150
        },
        {
          title: '操作',
          slot: 'action',
          fixed: 'right',
          minWidth: 150
        }

      ]
    }
  },
  created() {
    this.loadTableData()
  },
  activated() {
    this.loadTableData()
  },
  methods: {
    loadTableData() {
      this.loading = true
      plantDeviceMeteorologyListApi().then(res => {
        this.tableData = res.data
        this.loading = false
      }).catch(res => {
        this.loading = false
        this.$Message.error(res.msg)
      })
    },
    // 历史记录
    log(device_sn) {
      this.$router.push({path: this.pathFormat(this.$route.path, 'log/list', device_sn)})
    },

    // 编辑
    edit(id){
      this.$router.push({path: '/admin/device/edit/' + id})
    },
  }
}
</script>
